import { createSelectorByActionName } from '../utils/toolkit';
import { ReduxState } from '../types';

const reducerName = 'errors';

export const createErrorSelector = createSelectorByActionName(reducerName);

export const createErrorPayloadSelector = <T>(actionName: string): ((state: ReduxState) => T) =>
  createSelectorByActionName<T>(reducerName)(actionName, true) as (state: ReduxState) => T;
